// src/features/user/userSlice.js
import { createSlice } from '@reduxjs/toolkit';
import { ORDER } from '../constants/storeConstants';

const initialState = {
  isFetchOrderLoading: false,
  isFetchOrderSuccess: false,
  isFetchOrderError: false,
  fetchOrderData: null,
  fetchOrderError: null,
};

const orderSlice = createSlice({
  name: ORDER,
  initialState,
  reducers: {
    getShopOrder: (state) => {
      state.isFetchOrderLoading = true;
      state.isFetchOrderError = false;
      state.isFetchOrderSuccess = false;
      state.fetchOrderError = null;
    },
    getShopOrderSuccess: (state, action) => {
      state.isFetchOrderLoading = false;
      state.isFetchOrderSuccess = true;
      state.isFetchOrderError = false;
      state.fetchOrderData = action.payload;
    },
    getShopOrderError: (state, action) => {
      state.isFetchOrderLoading = false;
      state.isFetchOrderError = true;
      state.fetchOrderError = action.payload;
    }
  },
});

export const {
  getShopOrder,
  getShopOrderSuccess,
  getShopOrderError } = orderSlice.actions;

export default orderSlice.reducer;
